import { t } from "i18next"
import {
  type PointOfCareType,
  type ReasonForChoosingType,
  ReasonForChoosingTypeValues,
} from "@/types/__generated__/union-types"

const MEDICAL_POINT_OF_CARE_FIELD = "medicalPointOfCare"
const ACTUAL_POINT_OF_CARE_FIELD = "actualPointOfCare"

const SHOULD_VALIDATE_AND_DIRTY = { shouldValidate: true, shouldDirty: true }

const POINT_OF_CARE_NOT_FOR_DOCTOR_VISIT: (PointOfCareType | undefined | null)[] = [
  "EMERGENCY_CALL",
  "INCOMPLETE_TELECONSULTATION",
  "TELECARE",
  "MEDICAL_EMERGENCY_OR_PERMANENCE",
  "HOSPITAL_EMERGENCY_ROOM",
  "EXTERNAL_ASSISTANCE",
]

const POINT_OF_CARE_NOT_SELECTABLE_AS_ACTUAL: PointOfCareType[] = ["INCOMPLETE_TELECONSULTATION", "EXTERNAL_ASSISTANCE"]

const TIME_TO_TREAT_POINTS_OF_CARE = [
  "GENERAL_PRACTITIONER",
  "SPECIALIST",
  "HOSPITAL_ELECTIVE",
  "HOSPITAL_EMERGENCY_ROOM",
  "MEDICAL_EMERGENCY_OR_PERMANENCE",
] as const satisfies readonly PointOfCareType[]

const isTimeToTreatPointOfCare = (
  pointOfCare: PointOfCareType,
): pointOfCare is (typeof TIME_TO_TREAT_POINTS_OF_CARE)[number] =>
  TIME_TO_TREAT_POINTS_OF_CARE.some((candidate) => candidate === pointOfCare)

const isNotForDoctorVisit = (medicalValue: PointOfCareType | undefined | null) =>
  POINT_OF_CARE_NOT_FOR_DOCTOR_VISIT.includes(medicalValue)

const isReasonForChoosingType = (value: string): value is ReasonForChoosingType =>
  ReasonForChoosingTypeValues.some((candidate) => candidate === value)

type ReasonPointOfCareItem = { value: ReasonForChoosingType; label: string; tooltip: string }

const REASON_POINT_OF_CARE_ITEMS: ReasonPointOfCareItem[] = [
  {
    value: "TIME",
    label: t("episodeOfCare.progressNote.pointOfCare.reasonList.TIME"),
    tooltip: t("episodeOfCare.progressNote.pointOfCare.reasonTooltipList.time"),
  },
  {
    value: "INFRASTRUCTURE",
    label: t("episodeOfCare.progressNote.pointOfCare.reasonList.INFRASTRUCTURE"),
    tooltip: t("episodeOfCare.progressNote.pointOfCare.reasonTooltipList.infrastructure"),
  },
  {
    value: "PATIENT_REQUEST",
    label: t("episodeOfCare.progressNote.pointOfCare.reasonList.PATIENT_REQUEST"),
    tooltip: "",
  },
]

const PURPOSE_POINT_OF_CARE_ITEMS = [
  { value: "physicalExam", label: t("episodeOfCare.progressNote.pointOfCare.purposeOptionList.physicalExam") },
  { value: "laboratory", label: t("episodeOfCare.progressNote.pointOfCare.purposeOptionList.laboratory") },
  {
    value: "instrumentalExamination",
    label: t("episodeOfCare.progressNote.pointOfCare.purposeOptionList.instrumentalExamination"),
  },
] as const

export {
  ACTUAL_POINT_OF_CARE_FIELD,
  isNotForDoctorVisit,
  isReasonForChoosingType,
  isTimeToTreatPointOfCare,
  MEDICAL_POINT_OF_CARE_FIELD,
  POINT_OF_CARE_NOT_FOR_DOCTOR_VISIT,
  POINT_OF_CARE_NOT_SELECTABLE_AS_ACTUAL,
  PURPOSE_POINT_OF_CARE_ITEMS,
  REASON_POINT_OF_CARE_ITEMS,
  SHOULD_VALIDATE_AND_DIRTY,
  TIME_TO_TREAT_POINTS_OF_CARE,
}
